export const meishu = [ //美术半岛坐标点
    { lng: 106.492523, lat: 29.498616 },
    { lng: 106.500716, lat: 29.502938 },
    { lng: 106.515591, lat: 29.506207 },
    { lng: 106.536648, lat: 29.515322 },
    { lng: 106.540241, lat: 29.517145 },
    { lng: 106.540744, lat: 29.514882 },
    { lng: 106.542397, lat: 29.511236 },
    { lng: 106.545271, lat: 29.507904 },
    { lng: 106.549224, lat: 29.505516 },
    { lng: 106.554614, lat: 29.503881 },
    { lng: 106.557776, lat: 29.501618 },
    { lng: 106.559285, lat: 29.498663 },
    { lng: 106.560363, lat: 29.492061 },
    { lng: 106.558638, lat: 29.486717 },
    { lng: 106.556482, lat: 29.483069 },
    { lng: 106.553392, lat: 29.480617 },
    { lng: 106.550158, lat: 29.479108 },
    { lng: 106.546062, lat: 29.479422 },
    { lng: 106.542469, lat: 29.481435 },
    { lng: 106.539882, lat: 29.482755 },
    { lng: 106.53018, lat: 29.486654 },
    { lng: 106.531114, lat: 29.491432 },
    { lng: 106.529892, lat: 29.493822 },
    { lng: 106.527737, lat: 29.495205 },
    { lng: 106.526299, lat: 29.494702 },
    { lng: 106.526084, lat: 29.493319 },
    { lng: 106.524503, lat: 29.493444 },
    { lng: 106.522347, lat: 29.494702 },
    { lng: 106.519472, lat: 29.495456 },
    { lng: 106.515376, lat: 29.496525 },
    { lng: 106.511783, lat: 29.498914 },
    { lng: 106.509914, lat: 29.4986 },
    { lng: 106.509052, lat: 29.496777 },
    { lng: 106.508477, lat: 29.495205 },
    { lng: 106.506824, lat: 29.49489 },
    { lng: 106.504452, lat: 29.497971 },
    { lng: 106.502871, lat: 29.499292 },
    { lng: 106.499997, lat: 29.498286 },
    { lng: 106.498488, lat: 29.497217 },
    { lng: 106.496332, lat: 29.497594 },
]

export const xinshangquan = [
    { lng: 106.492406, lat: 29.498726 },
    { lng: 106.492406, lat: 29.498726 },
    { lng: 106.501066, lat: 29.503253 },
    { lng: 106.516086, lat: 29.506145 },
    { lng: 106.536351, lat: 29.515386 },
    { lng: 106.540376, lat: 29.517649 },
    { lng: 106.539945, lat: 29.524123 },
    { lng: 106.539657, lat: 29.534022 },
    { lng: 106.534267, lat: 29.534336 },
    { lng: 106.532183, lat: 29.535593 },
    { lng: 106.529812, lat: 29.535531 },
    { lng: 106.527081, lat: 29.538233 },
    { lng: 106.525284, lat: 29.53729 },
    { lng: 106.524853, lat: 29.534902 },
    { lng: 106.521907, lat: 29.534274 },
    { lng: 106.521835, lat: 29.534148 },
    { lng: 106.517379, lat: 29.534651 },
    { lng: 106.515223, lat: 29.535342 },
    { lng: 106.512421, lat: 29.533268 },
    { lng: 106.509259, lat: 29.533142 },
    { lng: 106.507749, lat: 29.535468 },
    { lng: 106.508971, lat: 29.541061 },
    { lng: 106.506097, lat: 29.542884 },
    { lng: 106.505593, lat: 29.547911 },
    { lng: 106.503438, lat: 29.551618 },
    { lng: 106.498263, lat: 29.552372 },
    { lng: 106.487556, lat: 29.553189 },
    { lng: 106.489496, lat: 29.548791 },
    { lng: 106.490143, lat: 29.544643 },
    { lng: 106.486693, lat: 29.543261 },
    { lng: 106.482597, lat: 29.540433 },
    { lng: 106.47965, lat: 29.540244 },
    { lng: 106.47771, lat: 29.541501 },
    { lng: 106.471314, lat: 29.540998 },
    { lng: 106.470236, lat: 29.542192 },
    { lng: 106.468583, lat: 29.540181 },
    { lng: 106.467218, lat: 29.537793 },
    { lng: 106.467721, lat: 29.534022 },
    { lng: 106.462834, lat: 29.531885 },
    { lng: 106.461612, lat: 29.528051 },
    { lng: 106.459097, lat: 29.525851 },
    { lng: 106.457804, lat: 29.521452 },
    { lng: 106.456007, lat: 29.519629 },
    { lng: 106.466499, lat: 29.520572 },
    { lng: 106.471745, lat: 29.520006 },
    { lng: 106.480441, lat: 29.523149 },
    { lng: 106.4854, lat: 29.523652 },
    { lng: 106.490574, lat: 29.526166 },
    { lng: 106.495964, lat: 29.529371 },
    { lng: 106.500491, lat: 29.529371 },
    { lng: 106.503078, lat: 29.527486 },
    { lng: 106.505234, lat: 29.524657 },
    { lng: 106.504156, lat: 29.522772 },
    { lng: 106.502072, lat: 29.522332 },
    { lng: 106.499413, lat: 29.521829 },
    { lng: 106.497688, lat: 29.520572 },
    { lng: 106.496467, lat: 29.517429 },
    { lng: 106.494526, lat: 29.519943 },
    { lng: 106.492514, lat: 29.521074 },
    { lng: 106.491221, lat: 29.521954 },
    { lng: 106.490071, lat: 29.520886 },
    { lng: 106.490574, lat: 29.520194 },
    { lng: 106.492155, lat: 29.51856 },
    { lng: 106.49158, lat: 29.517869 },
    { lng: 106.489065, lat: 29.517869 },
    { lng: 106.487268, lat: 29.518183 },
    { lng: 106.486118, lat: 29.517617 },
    { lng: 106.486118, lat: 29.516737 },
    { lng: 106.486262, lat: 29.515606 },
    { lng: 106.484825, lat: 29.516234 },
    { lng: 106.483459, lat: 29.51812 },
    { lng: 106.482453, lat: 29.519189 },
    { lng: 106.480657, lat: 29.517931 },
    { lng: 106.48001, lat: 29.515354 },
    { lng: 106.477423, lat: 29.513531 },
    { lng: 106.472248, lat: 29.510891 },
    { lng: 106.468727, lat: 29.507496 },
    { lng: 106.466859, lat: 29.50297 },
    { lng: 106.465852, lat: 29.501084 },
    { lng: 106.46614, lat: 29.501021 },
    { lng: 106.470596, lat: 29.500958 },
    { lng: 106.473542, lat: 29.501335 },
    { lng: 106.476345, lat: 29.502215 },
    { lng: 106.479219, lat: 29.502278 },
    { lng: 106.480944, lat: 29.50165 },
    { lng: 106.4831, lat: 29.501398 },
    { lng: 106.486406, lat: 29.500958 },
    { lng: 106.488418, lat: 29.500644 },
    { lng: 106.490286, lat: 29.499575 },
]
export const gaotie = [
    { lng: 106.456016, lat: 29.519609 },
    { lng: 106.46649, lat: 29.520587 },
    { lng: 106.471727, lat: 29.520013 },
    { lng: 106.480441, lat: 29.52316 },
    { lng: 106.485386, lat: 29.523667 },
    { lng: 106.490569, lat: 29.526173 },
    { lng: 106.495954, lat: 29.529383 },
    { lng: 106.500473, lat: 29.529375 },
    { lng: 106.503083, lat: 29.527485 },
    { lng: 106.505234, lat: 29.524669 },
    { lng: 106.504161, lat: 29.522787 },
    { lng: 106.499413, lat: 29.521844 },
    { lng: 106.497697, lat: 29.520583 },
    { lng: 106.496453, lat: 29.51744 },
    { lng: 106.494526, lat: 29.519939 },
    { lng: 106.491225, lat: 29.521946 },
    { lng: 106.490062, lat: 29.520889 },
    { lng: 106.490578, lat: 29.520198 },
    { lng: 106.492146, lat: 29.518575 },
    { lng: 106.491571, lat: 29.517876 },
    { lng: 106.489056, lat: 29.517864 },
    { lng: 106.487277, lat: 29.518186 },
    { lng: 106.486118, lat: 29.517625 },
    { lng: 106.486118, lat: 29.516741 },
    { lng: 106.486253, lat: 29.515625 },
    { lng: 106.484824, lat: 29.516234 },
    { lng: 106.483468, lat: 29.518108 },
    { lng: 106.482462, lat: 29.51918 },
    { lng: 106.480638, lat: 29.517927 },
    { lng: 106.480014, lat: 29.515358 },
    { lng: 106.477427, lat: 29.513539 },
    { lng: 106.472253, lat: 29.510894 },
    { lng: 106.468722, lat: 29.5075 },
    { lng: 106.466849, lat: 29.502985 },
    { lng: 106.465852, lat: 29.501091 },
    { lng: 106.465587, lat: 29.500097 },
    { lng: 106.465457, lat: 29.4995 },
    { lng: 106.465444, lat: 29.498667 },
    { lng: 106.464976, lat: 29.497295 },
    { lng: 106.464415, lat: 29.496875 },
    { lng: 106.463818, lat: 29.496714 },
    { lng: 106.463315, lat: 29.496832 },
    { lng: 106.462223, lat: 29.497374 },
    { lng: 106.461774, lat: 29.497295 },
    { lng: 106.461024, lat: 29.496505 },
    { lng: 106.461383, lat: 29.494651 },
    { lng: 106.461469, lat: 29.493873 },
    { lng: 106.461473, lat: 29.492906 },
    { lng: 106.4611, lat: 29.490033 },
    { lng: 106.46115, lat: 29.489511 },
    { lng: 106.461343, lat: 29.489063 },
    { lng: 106.462138, lat: 29.488186 },
    { lng: 106.463211, lat: 29.487558 },
    { lng: 106.463997, lat: 29.487212 },
    { lng: 106.4645, lat: 29.487058 },
    { lng: 106.4657, lat: 29.487051 },
    { lng: 106.466504, lat: 29.487444 },
    { lng: 106.467595, lat: 29.488607 },
    { lng: 106.468471, lat: 29.489334 },
    { lng: 106.468884, lat: 29.48957 },
    { lng: 106.469441, lat: 29.489684 },
    { lng: 106.469877, lat: 29.489699 },
    { lng: 106.473034, lat: 29.488481 },
    { lng: 106.47382, lat: 29.48784 },
    { lng: 106.474458, lat: 29.486933 },
    { lng: 106.476439, lat: 29.482771 },
    { lng: 106.476753, lat: 29.481808 },
    { lng: 106.476803, lat: 29.481077 },
    { lng: 106.476686, lat: 29.4802 },
    { lng: 106.476282, lat: 29.479218 },
    { lng: 106.476035, lat: 29.478935 },
    { lng: 106.474957, lat: 29.47853 },
    { lng: 106.474049, lat: 29.478436 },
    { lng: 106.473304, lat: 29.478286 },
    { lng: 106.473097, lat: 29.478172 },
    { lng: 106.471309, lat: 29.47638 },
    { lng: 106.471035, lat: 29.476298 },
    { lng: 106.470591, lat: 29.476255 },
    { lng: 106.47002, lat: 29.476274 },
    { lng: 106.46706, lat: 29.477386 },
    { lng: 106.466513, lat: 29.477371 },
    { lng: 106.46565, lat: 29.477217 },
    { lng: 106.465183, lat: 29.47706 },
    { lng: 106.464626, lat: 29.476569 },
    { lng: 106.464437, lat: 29.47627 },
    { lng: 106.464482, lat: 29.475873 },
    { lng: 106.464343, lat: 29.475457 },
    { lng: 106.464051, lat: 29.475091 },
    { lng: 106.463988, lat: 29.474863 },
    { lng: 106.464015, lat: 29.474631 },
    { lng: 106.464101, lat: 29.47438 },
    { lng: 106.464213, lat: 29.474219 },
    { lng: 106.464253, lat: 29.474085 },
    { lng: 106.464289, lat: 29.473786 },
    { lng: 106.464213, lat: 29.473586 },
    { lng: 106.46388, lat: 29.473091 },
    { lng: 106.463472, lat: 29.4728 },
    { lng: 106.463018, lat: 29.472544 },
    { lng: 106.462057, lat: 29.471338 },
    { lng: 106.462039, lat: 29.471251 },
    { lng: 106.462043, lat: 29.471058 },
    { lng: 106.46207, lat: 29.470968 },
    { lng: 106.46252, lat: 29.470056 },
    { lng: 106.462538, lat: 29.469836 },
    { lng: 106.462259, lat: 29.469439 },
    { lng: 106.462138, lat: 29.469412 },
    { lng: 106.461967, lat: 29.469258 },
    { lng: 106.46168, lat: 29.469113 },
    { lng: 106.461608, lat: 29.469015 },
    { lng: 106.461576, lat: 29.468806 },
    { lng: 106.461612, lat: 29.468425 },
    { lng: 106.461572, lat: 29.468071 },
    { lng: 106.461495, lat: 29.467765 },
    { lng: 106.461343, lat: 29.467513 },
    { lng: 106.460772, lat: 29.467175 },
    { lng: 106.460413, lat: 29.467085 },
    { lng: 106.460067, lat: 29.466943 },
    { lng: 106.459995, lat: 29.466884 },
    { lng: 106.459937, lat: 29.46677 },
    { lng: 106.459879, lat: 29.466436 },
    { lng: 106.459946, lat: 29.465992 },
    { lng: 106.459897, lat: 29.465045 },
    { lng: 106.459757, lat: 29.46451 },
    { lng: 106.459317, lat: 29.463649 },
    { lng: 106.458863, lat: 29.462277 },
    { lng: 106.458733, lat: 29.461259 },
    { lng: 106.459043, lat: 29.460335 },
    { lng: 106.459438, lat: 29.460001 },
    { lng: 106.45982, lat: 29.459872 },
    { lng: 106.459955, lat: 29.459844 },
    { lng: 106.462659, lat: 29.459927 },
    { lng: 106.462982, lat: 29.459911 },
    { lng: 106.463171, lat: 29.459734 },
    { lng: 106.463997, lat: 29.454946 },
    { lng: 106.464428, lat: 29.454372 },
    { lng: 106.465066, lat: 29.453767 },
    { lng: 106.465915, lat: 29.453311 },
    { lng: 106.466292, lat: 29.453063 },
    { lng: 106.46662, lat: 29.452784 },
    { lng: 106.466688, lat: 29.452591 },
    { lng: 106.466778, lat: 29.452186 },
    { lng: 106.466782, lat: 29.452025 },
    { lng: 106.466697, lat: 29.451754 },
    { lng: 106.465156, lat: 29.451133 },
    { lng: 106.464608, lat: 29.450197 },
    { lng: 106.464195, lat: 29.448074 },
    { lng: 106.463939, lat: 29.44728 },
    { lng: 106.463975, lat: 29.446973 },
    { lng: 106.464428, lat: 29.445849 },
    { lng: 106.464451, lat: 29.445349 },
    { lng: 106.46358, lat: 29.442479 },
    { lng: 106.462183, lat: 29.440211 },
    { lng: 106.460894, lat: 29.435642 },
    { lng: 106.460997, lat: 29.434604 },
    { lng: 106.462699, lat: 29.432347 },
    { lng: 106.463243, lat: 29.431281 },
    { lng: 106.463337, lat: 29.43081 },
    { lng: 106.46335, lat: 29.430165 },
    { lng: 106.463256, lat: 29.429441 },
    { lng: 106.463054, lat: 29.428623 },
    { lng: 106.463063, lat: 29.428029 },
    { lng: 106.463463, lat: 29.426079 },
    { lng: 106.463494, lat: 29.425548 },
    { lng: 106.463418, lat: 29.42512 },
    { lng: 106.463247, lat: 29.424652 },
    { lng: 106.462856, lat: 29.424144 },
    { lng: 106.460741, lat: 29.422005 },
    { lng: 106.459645, lat: 29.420703 },
    { lng: 106.458967, lat: 29.42035 },
    { lng: 106.458724, lat: 29.420271 },
    { lng: 106.458203, lat: 29.420212 },
    { lng: 106.457462, lat: 29.420342 },
    { lng: 106.456326, lat: 29.420912 },
    { lng: 106.456043, lat: 29.421148 },
    { lng: 106.455935, lat: 29.42149 },
    { lng: 106.455755, lat: 29.422902 },
    { lng: 106.455383, lat: 29.42379 },
    { lng: 106.455216, lat: 29.423987 },
    { lng: 106.454862, lat: 29.42414 },
    { lng: 106.454421, lat: 29.424219 },
    { lng: 106.453793, lat: 29.424231 },
    { lng: 106.453258, lat: 29.42416 },
    { lng: 106.451542, lat: 29.423787 },
    { lng: 106.450931, lat: 29.423838 },
    { lng: 106.45072, lat: 29.423904 },
    { lng: 106.449871, lat: 29.424447 },
    { lng: 106.449656, lat: 29.42615 },
    { lng: 106.449615, lat: 29.427558 },
    { lng: 106.449229, lat: 29.428269 },
    { lng: 106.448888, lat: 29.428533 },
    { lng: 106.448551, lat: 29.428663 },
    { lng: 106.448052, lat: 29.428663 },
    { lng: 106.447733, lat: 29.428611 },
    { lng: 106.447406, lat: 29.428446 },
    { lng: 106.447105, lat: 29.428179 },
    { lng: 106.446934, lat: 29.4279 },
    { lng: 106.446853, lat: 29.427546 },
    { lng: 106.446871, lat: 29.427027 },
    { lng: 106.447491, lat: 29.423433 },
    { lng: 106.447455, lat: 29.422827 },
    { lng: 106.447298, lat: 29.422548 },
    { lng: 106.446786, lat: 29.422096 },
    { lng: 106.44604, lat: 29.422088 },
    { lng: 106.444257, lat: 29.423452 },
    { lng: 106.442734, lat: 29.423617 },
    { lng: 106.442254, lat: 29.423519 },
    { lng: 106.441387, lat: 29.422851 },
    { lng: 106.441064, lat: 29.422481 },
    { lng: 106.441019, lat: 29.422182 },
    { lng: 106.440938, lat: 29.422123 },
    { lng: 106.440403, lat: 29.42193 },
    { lng: 106.440322, lat: 29.421628 },
    { lng: 106.440165, lat: 29.421415 },
    { lng: 106.439438, lat: 29.420943 },
    { lng: 106.438921, lat: 29.420747 },
    { lng: 106.438449, lat: 29.420696 },
    { lng: 106.437551, lat: 29.420778 },
    { lng: 106.437205, lat: 29.420987 },
    { lng: 106.436819, lat: 29.421498 },
    { lng: 106.436289, lat: 29.422607 },
    { lng: 106.436401, lat: 29.425702 },
    { lng: 106.43641, lat: 29.426429 },
    { lng: 106.436195, lat: 29.427172 },
    { lng: 106.435476, lat: 29.427754 },
    { lng: 106.433396, lat: 29.428733 },
    { lng: 106.432543, lat: 29.429697 },
    { lng: 106.431461, lat: 29.430629 },
    { lng: 106.430023, lat: 29.431364 },
    { lng: 106.429332, lat: 29.431384 },
    { lng: 106.428577, lat: 29.431207 },
    { lng: 106.428326, lat: 29.431112 },
    { lng: 106.427975, lat: 29.430695 },
    { lng: 106.42784, lat: 29.430302 },
    { lng: 106.427814, lat: 29.429988 },
    { lng: 106.428047, lat: 29.429115 },
    { lng: 106.428793, lat: 29.428407 },
    { lng: 106.429062, lat: 29.427951 },
    { lng: 106.42917, lat: 29.427518 },
    { lng: 106.429017, lat: 29.42685 },
    { lng: 106.428604, lat: 29.426189 },
    { lng: 106.428137, lat: 29.425969 },
    { lng: 106.427526, lat: 29.425812 },
    { lng: 106.427194, lat: 29.42578 },
    { lng: 106.426179, lat: 29.42582 },
    { lng: 106.424822, lat: 29.426173 },
    { lng: 106.423942, lat: 29.426464 },
    { lng: 106.423322, lat: 29.426834 },
    { lng: 106.422621, lat: 29.42733 },
    { lng: 106.421849, lat: 29.4288 },
    { lng: 106.421795, lat: 29.429366 },
    { lng: 106.42228, lat: 29.431057 },
    { lng: 106.422406, lat: 29.433291 },
    { lng: 106.422289, lat: 29.435846 },
    { lng: 106.421975, lat: 29.436483 },
    { lng: 106.421723, lat: 29.436806 },
    { lng: 106.421256, lat: 29.43716 },
    { lng: 106.420618, lat: 29.437498 },
    { lng: 106.419235, lat: 29.437922 },
    { lng: 106.418031, lat: 29.438386 },
    { lng: 106.416558, lat: 29.439535 },
    { lng: 106.416082, lat: 29.440392 },
    { lng: 106.415327, lat: 29.44257 },
    { lng: 106.415228, lat: 29.44345 },
    { lng: 106.414941, lat: 29.443985 },
    { lng: 106.414608, lat: 29.444315 },
    { lng: 106.414303, lat: 29.444496 },
    { lng: 106.413944, lat: 29.444504 },
    { lng: 106.413441, lat: 29.444504 },
    { lng: 106.411707, lat: 29.444245 },
    { lng: 106.410413, lat: 29.444245 },
    { lng: 106.407611, lat: 29.444748 },
    { lng: 106.406137, lat: 29.445314 },
    { lng: 106.404898, lat: 29.445361 },
    { lng: 106.413144, lat: 29.49891 },
    { lng: 106.414051, lat: 29.49858 },
    { lng: 106.417654, lat: 29.49891 },
    { lng: 106.419837, lat: 29.498792 },
    { lng: 106.421903, lat: 29.498572 },
    { lng: 106.423493, lat: 29.498549 },
    { lng: 106.424166, lat: 29.49869 },
    { lng: 106.426475, lat: 29.499885 },
    { lng: 106.427185, lat: 29.500066 },
    { lng: 106.428227, lat: 29.500105 },
    { lng: 106.430428, lat: 29.500026 },
    { lng: 106.431056, lat: 29.500215 },
    { lng: 106.431604, lat: 29.500537 },
    { lng: 106.432036, lat: 29.50115 },
    { lng: 106.433015, lat: 29.503366 },
    { lng: 106.433679, lat: 29.504278 },
    { lng: 106.434668, lat: 29.50504 },
    { lng: 106.437776, lat: 29.504954 },
    { lng: 106.440057, lat: 29.504262 },
    { lng: 106.440345, lat: 29.502313 },
    { lng: 106.440345, lat: 29.500333 },
    { lng: 106.44056, lat: 29.499201 },
    { lng: 106.441603, lat: 29.498667 },
    { lng: 106.442716, lat: 29.498541 },
    { lng: 106.444297, lat: 29.498635 },
    { lng: 106.445016, lat: 29.499453 },
    { lng: 106.445268, lat: 29.501244 },
    { lng: 106.446058, lat: 29.501747 },
    { lng: 106.446669, lat: 29.501622 },
    { lng: 106.447603, lat: 29.501276 },
    { lng: 106.448394, lat: 29.501276 },
    { lng: 106.450945, lat: 29.504294 },
    { lng: 106.450514, lat: 29.505268 },
    { lng: 106.450622, lat: 29.506368 },
    { lng: 106.45108, lat: 29.506718 },
    { lng: 106.451641, lat: 29.507009 },
    { lng: 106.452935, lat: 29.507181 },
    { lng: 106.453379, lat: 29.507311 },
    { lng: 106.453698, lat: 29.507669 },
    { lng: 106.454547, lat: 29.510062 },
    { lng: 106.454924, lat: 29.511924 },
    { lng: 106.455162, lat: 29.512234 },
    { lng: 106.45532, lat: 29.51256 },
    { lng: 106.455311, lat: 29.513189 },
    { lng: 106.455185, lat: 29.513704 },
    { lng: 106.454884, lat: 29.514529 },
    { lng: 106.454543, lat: 29.51612 },
    { lng: 106.454529, lat: 29.516855 },
    { lng: 106.454821, lat: 29.517797 },
    { lng: 106.455055, lat: 29.518336 },
]

export const xibu = [
    { lng: 106.337304, lat: 29.402392 },
    { lng: 106.341329, lat: 29.395847 },
    { lng: 106.345497, lat: 29.395092 },
    { lng: 106.346359, lat: 29.397861 },
    { lng: 106.348515, lat: 29.397358 },
    { lng: 106.349809, lat: 29.399623 },
    { lng: 106.353833, lat: 29.399623 },
    { lng: 106.357858, lat: 29.398365 },
    { lng: 106.358576, lat: 29.396728 },
    { lng: 106.362888, lat: 29.393959 },
    { lng: 106.36605, lat: 29.393581 },
    { lng: 106.367775, lat: 29.397358 },
    { lng: 106.365619, lat: 29.400127 },
    { lng: 106.36605, lat: 29.402896 },
    { lng: 106.370075, lat: 29.401763 },
    { lng: 106.37453, lat: 29.400504 },
    { lng: 106.377836, lat: 29.403273 },
    { lng: 106.380423, lat: 29.404154 },
    { lng: 106.385454, lat: 29.402266 },
    { lng: 106.389047, lat: 29.399749 },
    { lng: 106.390628, lat: 29.402015 },
    { lng: 106.395658, lat: 29.401008 },
    { lng: 106.399252, lat: 29.39912 },
    { lng: 106.40227, lat: 29.399372 },
    { lng: 106.403995, lat: 29.399246 },
    { lng: 106.403564, lat: 29.397232 },
    { lng: 106.401839, lat: 29.394463 },
    { lng: 106.405001, lat: 29.391064 },
    { lng: 106.409313, lat: 29.38842 },
    { lng: 106.412187, lat: 29.38477 },
    { lng: 106.41305, lat: 29.380364 },
    { lng: 106.414199, lat: 29.377468 },
    { lng: 106.413481, lat: 29.375202 },
    { lng: 106.414918, lat: 29.372432 },
    { lng: 106.412331, lat: 29.369285 },
    { lng: 106.410462, lat: 29.367144 },
    { lng: 106.408738, lat: 29.364752 },
    { lng: 106.402701, lat: 29.363367 },
    { lng: 106.40227, lat: 29.360723 },
    { lng: 106.404426, lat: 29.357197 },
    { lng: 106.406438, lat: 29.350901 },
    { lng: 106.406726, lat: 29.34876 },
    { lng: 106.406438, lat: 29.346619 },
    { lng: 106.401695, lat: 29.345486 },
    { lng: 106.399539, lat: 29.341708 },
    { lng: 106.398102, lat: 29.336418 },
    { lng: 106.397886, lat: 29.333584 },
    { lng: 106.396665, lat: 29.331632 },
    { lng: 106.395227, lat: 29.328672 },
    { lng: 106.394077, lat: 29.326909 },
    { lng: 106.392784, lat: 29.324264 },
    { lng: 106.39185, lat: 29.321745 },
    { lng: 106.392065, lat: 29.31891 },
    { lng: 106.392496, lat: 29.312486 },
    { lng: 106.395802, lat: 29.307951 },
    { lng: 106.397527, lat: 29.302281 },
    { lng: 106.398317, lat: 29.299005 },
    { lng: 106.396665, lat: 29.29573 },
    { lng: 106.395443, lat: 29.292832 },
    { lng: 106.391347, lat: 29.291194 },
    { lng: 106.384807, lat: 29.287225 },
    { lng: 106.375177, lat: 29.285334 },
    { lng: 106.368637, lat: 29.285523 },
    { lng: 106.365475, lat: 29.284767 },
    { lng: 106.362098, lat: 29.28357 },
    { lng: 106.359654, lat: 29.282436 },
    { lng: 106.354839, lat: 29.280483 },
    { lng: 106.34794, lat: 29.273426 },
    { lng: 106.343054, lat: 29.271031 },
    { lng: 106.334071, lat: 29.267187 },
    { lng: 106.329759, lat: 29.265612 },
    { lng: 106.32595, lat: 29.264352 },
    { lng: 106.322429, lat: 29.263028 },
    { lng: 106.317901, lat: 29.26202 },
    { lng: 106.309205, lat: 29.262272 },
    { lng: 106.304175, lat: 29.26328 },
    { lng: 106.301229, lat: 29.267502 },
    { lng: 106.297635, lat: 29.278593 },
    { lng: 106.292317, lat: 29.286279 },
    { lng: 106.286137, lat: 29.291068 },
    { lng: 106.288293, lat: 29.29699 },
    { lng: 106.291742, lat: 29.298124 },
    { lng: 106.288868, lat: 29.306817 },
    { lng: 106.292605, lat: 29.310344 },
    { lng: 106.29318, lat: 29.313871 },
    { lng: 106.291742, lat: 29.316895 },
    { lng: 106.294761, lat: 29.318532 },
    { lng: 106.295192, lat: 29.322185 },
    { lng: 106.295192, lat: 29.323697 },
    { lng: 106.295623, lat: 29.32672 },
    { lng: 106.294186, lat: 29.328735 },
    { lng: 106.289874, lat: 29.329617 },
    { lng: 106.287287, lat: 29.327224 },
    { lng: 106.285275, lat: 29.327224 },
    { lng: 106.281969, lat: 29.328861 },
    { lng: 106.281825, lat: 29.332766 },
    { lng: 106.279669, lat: 29.335033 },
    { lng: 106.275214, lat: 29.335411 },
    { lng: 106.27162, lat: 29.33667 },
    { lng: 106.268458, lat: 29.339441 },
    { lng: 106.269464, lat: 29.344479 },
    { lng: 106.273058, lat: 29.35002 },
    { lng: 106.276363, lat: 29.353042 },
    { lng: 106.275932, lat: 29.355057 },
    { lng: 106.277082, lat: 29.357575 },
    { lng: 106.282688, lat: 29.358205 },
    { lng: 106.285562, lat: 29.360219 },
    { lng: 106.284412, lat: 29.365885 },
    { lng: 106.283119, lat: 29.366767 },
    { lng: 106.281825, lat: 29.368907 },
    { lng: 106.284843, lat: 29.372432 },
    { lng: 106.289012, lat: 29.37495 },
    { lng: 106.28973, lat: 29.379986 },
    { lng: 106.286999, lat: 29.381623 },
    { lng: 106.288149, lat: 29.384266 },
    { lng: 106.288724, lat: 29.387413 },
    { lng: 106.291168, lat: 29.389553 },
    { lng: 106.291886, lat: 29.393204 },
    { lng: 106.294186, lat: 29.393204 },
    { lng: 106.297635, lat: 29.39333 },
    { lng: 106.300654, lat: 29.391316 },
    { lng: 106.29936, lat: 29.387288 },
    { lng: 106.301947, lat: 29.385022 },
    { lng: 106.306259, lat: 29.386406 },
    { lng: 106.309996, lat: 29.386406 },
    { lng: 106.312871, lat: 29.386155 },
    { lng: 106.314308, lat: 29.385525 },
    { lng: 106.314164, lat: 29.390435 },
    { lng: 106.316895, lat: 29.392449 },
    { lng: 106.318907, lat: 29.392323 },
    { lng: 106.321207, lat: 29.395218 },
    { lng: 106.324225, lat: 29.393959 },
    { lng: 106.327243, lat: 29.393959 },
    { lng: 106.329256, lat: 29.394966 },
    { lng: 106.329831, lat: 29.397358 },
    { lng: 106.331843, lat: 29.400001 },
    { lng: 106.335867, lat: 29.401385 },
]


